<template>
  <div class="mob-header">
    <div class="header-box">
      <router-link to="/mob">
        <div class="mob-logo">
          <img src="@/assets/image/mob/dahanLOGO.svg" alt="logo">
        </div>
      </router-link>
      <div :class="{menuShow:menuShow}" class="menu-btn" @click="menuShow = !menuShow"></div>
    </div>
    <div :class="{showHide:menuShow}" class="menu-list">
      <mob-menu :menuData="itemMob" menuEle="mob-header"></mob-menu>
    </div>
  </div>
</template>

<script>
import { itemMob } from '../assets/mobJson'
import MobMenu from './MobMenu'
export default {
  name: 'MobHeader',
  components: {
    MobMenu
  },
  data () {
    return {
      menuShow: false,
      itemMob
    }
  }
}
</script>

<style lang="less" scoped>
.mob-header {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  height: 1.2rem;
  background: #ffffff;
  transition: all 0.2s ease;
  box-shadow: 0px 4px 16px 0px rgba(0, 0, 0, 0.12);
  z-index: 100;
  .header-box {
    height: 100%;
    padding: 0.3rem;
    box-sizing: border-box;
    display: flex;
    justify-content: space-between;
    align-items: center;
    position: relative;
    z-index: 4;
    .mob-logo {
      width: 1.9rem;
      height: 0.6rem;
      img {
        display: block;
        width: 100%;
      }
    }
    .menu-btn {
      width: 0.4rem;
      height: 0.4rem;
      vertical-align: middle;
      background: url('../assets/image/mob/close_menu.svg') no-repeat;
      background-size: cover;
      margin: 0.1rem 0;
      &.menuShow {
        background: url('../assets/image/mob/show_menu.svg') no-repeat;
        background-size: cover;
      }
    }
  }
  .menu-list {
    position: absolute;
    width: 100%;
    left: 0;
    overflow: scroll;
    height: 0;
    background: #333333;
    transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
    will-change: transforml;
    z-index: 90;
    &.showHide {
      height: calc(100vh - 1.2rem);
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/MobHeader.vue